import { render, staticRenderFns } from "./LargeBlogPage.vue?vue&type=template&id=2cb8a2c2&"
import script from "./LargeBlogPage.vue?vue&type=script&lang=js&"
export * from "./LargeBlogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports